const DAY_MS = 24 * 60 * 60 * 1000;

const ecRetention = {
    FLOW_MS: 14 * DAY_MS,
    PUSH_MS: 7 * DAY_MS,
};

export default ecRetention;
